/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { TextField, MenuItem } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _, { isNaN } from 'lodash';
import {
  compareTwoDatesGreaterThanOrEqual,
  getUTCTimeStampMMDDYYYY,
} from '../../../../SharedModules/DateUtilities/DateUtilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import {
  getAllClientsDropDown,
  saveOrFailRes,
  saveOrUpdateGroup,
  setAddGroup,
  setCompareData,
  setGroupDataChangeTried,
  setGroupDetailsAndParticptionDates,
  setMainGroupDetailsAction,
  setMaintainGroupParticipationDatesAction,
  setNaviagtionListner,
  getAllPlans,
  setGroupTabDataAction,
  deleteGroup,
  getExistingCommentLinkIds,
  setCreateGrpOpt,
  setErrorPopup,
  dispatchClearsuccessFail
} from '../store/group-action';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import MaintainGroupTabContainer from './mainGroupTabContainer';
import * as message from '../../Plan/component/message';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CancellationPopup from '../../../Display/NDC/component/CancellationPopup';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import MainGroupParticipationDates from './mainGroupParticipationDates';
import MaintainGroupPlan from './maintainGroupPlan';
import { MAINTAIN_GROUP_PLANS, PARTICPATION_DATES } from './tableHeads';
import PlanContactForm from '../../Plan/component/planContactForm';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import { closeTab } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import { DELETE_GROUP_WARN } from '../../../../SharedModules/Errors/constantMessageData';
import {
  getAllContactType,
  getContactDetails,
  getExistingContactDetails,
  saveContactData,
  resetContactData as resetPlanContactData,
} from '../../Plan/store/actions';
import {
  checkActionAccessByRole,
  isReadOnly as isRead,
} from '../../../../SharedModules/utilities/utilities';

export const validDate = (d, value, fealed) => {
  if (value == null && fealed === 'start') {
    return false;
  }
  if (value === null && fealed === 'end') {
    return true;
  }
  let isValidDate = false;
  if (Object.prototype.toString.call(d) === '[object Date]') {
    isValidDate = true;

    if (isNaN(d)) {
      isValidDate = false;
    } else {
      isValidDate = true;
    }
  }
  return isValidDate;
};

export const isValidDateFormat = (date) => {
  const dateRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
  return dateRegex.test(date);
};

const MainGroup = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [errorMessages, setErrorMessages] = useState([]);
  const [successMessages, setSucessMessage] = useState([]);
  const [cancelPopup, setCancelPopup] = useState(false);
  const [savePopup, setSavePopup] = useState(false);
  const [disableSaveAndCancel, setDisableSaveAndCancel] = useState(true);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [tabValue, setTabValue] = useState('one');
  const [contactErrors, setContactErrors] = useState([]);
  const [contactFormDirty, setContactFormDirty] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [ccCommentsExist, setCcCommentsExist] = useState(0);
  const [resetContactSnapshot, setResetContactSnapshot] = useState(null);

  const groupDetails = useSelector(
    (state) => state.sharedState.GroupReducer.mainGroupDetails
  );
  const createfirst = useSelector(
    (state) => state.sharedState.GroupReducer.createfirst
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const selectedGroupDetail = useSelector(
    (state) => state.sharedState.GroupReducer.selectedGroup
  );

  const navigationListener = useSelector(
    (state) => state.sharedState.GroupReducer.navigationListener
  );
  const particpationDates = useSelector(
    (state) => state.sharedState.GroupReducer.particpationDates
  );

  const contactDetails = useSelector((state) => {
    return state.sharedState.GroupReducer.contactDetails;
  });

  const compareContactDetails = useSelector((state) => {
    return state.sharedState.GroupReducer.compareContactDetails;
  });

  const compareData = useSelector(
    (state) => state.sharedState.GroupReducer.compareData
  );

  const clientIdDropdown = useSelector(
    (state) => state.sharedState.GroupReducer.clientIdDropdown
  );

  const addGroup = useSelector(
    (state) => state.sharedState.GroupReducer.groupAdd
  );

  const errorPopup = useSelector(
    (state) => state.sharedState.GroupReducer.errorPopup
  );

  const dataChangeTried = useSelector(
    (state) => state.sharedState.GroupReducer.dataChangeTried
  );

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const plans = useSelector((state) => state.sharedState.GroupReducer.plans);
  const saveOrUpdateRes = useSelector(
    (state) => state.sharedState.GroupReducer.saveOrFailRes
  );

  const allContactData = useSelector((state) => {
    return state.sharedState.PlanReducer.allContactData;
  });

  const groupTabData = useSelector((state) => {
    return state.sharedState.GroupReducer.groupTabData;
  });
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly = isRead(props.location.pathname, loginState)?.readOnly || false;
  }
  const [hasAccessbyRole, setHasAccessbyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  React.useEffect(() => {   
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccessbyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);

  const Action = ({ setOpenDelete }) => {
    return (
      <Dropdown className="icon-dropdown-container">
        <Dropdown.Toggle
          className="icon-dropdown"
          style={{ float: 'right' }}
          aria-label="delete"
        >
          <SVGComponent iconName="Export-icon" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => setOpenDelete(true)}   
          disabled={!isEnablebyRole}>
            Delete Group
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const handleChangeTabValue = (event, newValue) => {
    setTabValue(newValue);
    setGroupTabData({
      ...groupTabData,
      tabValue: newValue,
    });
  };

  const handleSetErrorMessages = (messages) => {
    setErrorMessages(messages ?? []);
    setGroupTabData({
      ...groupTabData,
      errorMessages: messages,
    });
  };

  const handleSetDisableSaveAndCancel = (status) => {
    setDisableSaveAndCancel(status ?? true);
    setGroupTabData({
      ...groupTabData,
      disableSaveAndCancel: status,
    });
  };

  const setGroupTabData = (data) => {
    dispatch(setGroupTabDataAction(data));
  };

  const getExistingComments = async () => {
    if (selectedGroupDetail?.corrLinkId) {
      const res = await getExistingCommentLinkIds([
        selectedGroupDetail.corrLinkId,
      ]);
      setCcCommentsExist(res?.includes(selectedGroupDetail.corrLinkId) ? 1 : 0);
    }
  };

  useEffect(() => {
    dispatch(getAllClientsDropDown());
    dispatch(saveOrFailRes({}));
    dispatch(setErrorPopup(''));
    setSucessMessage([]);
    handleChangeTabValue({}, groupTabData?.tabValue ?? 'one');
    handleSetErrorMessages(groupTabData?.errorMessages ?? []);
    handleSetDisableSaveAndCancel(groupTabData?.disableSaveAndCancel ?? true);
    getExistingComments();
  }, []);

  useEffect(() => {
    getExistingComments();
  }, [showComments]);
  React.useEffect(() => {
    if (groupDetails?.groupId) {
      dispatch(
        getExistingContactDetails(
          {
            key: [
              `${groupDetails?.clientId?.trim()}${groupDetails?.groupId?.trim()}`,
            ],
            keyTypeCd: 'CG',
          },
          'group'
        )
      );
    }
    dispatch(getAllContactType({ keyTypeCd: 'CG' }, 'group'));

    return ()=>{
          dispatch(dispatchClearsuccessFail());
          dispatch(saveOrFailRes({}));
    }
  }, []);
  useEffect(() => {
    if (
      saveOrUpdateRes?.status === 200 &&
      saveOrUpdateRes?.data?.message === 'SUCESS'
    ) {
      setSucessMessage([message.SUCESS_MESSAGE]);
      handleSetDisableSaveAndCancel(true);
      setContactFormDirty(false);
      setTabValue(tabValue);
      dispatch(
        getExistingContactDetails(
          {
            key: [
              `${groupDetails?.clientId?.trim()}${groupDetails?.groupId?.trim()}`,
            ],
            keyTypeCd: 'CG',
          },
          'group'
        )
      );
      dispatch(getAllContactType({ keyTypeCd: 'CG' }, 'group'));
      dispatch(
        getContactDetails(
          {
            keyTypeCd: 'CG',
            key: `${groupDetails?.clientId?.trim()}${groupDetails?.groupId?.trim()}`,
            contactTypeCd: allContactData?.contactTypeCd,
          },
          'group'
        )
      );
      if (!clickOncloseTabBtn) {
        closeTab('/group-maintain', history, dispatch);
        dispatch(saveOrUpdateGroup(null));
      }
      dispatch(setAddGroup(false));
      callGetDetailsAPI();
    } else if (
      saveOrUpdateRes &&
      saveOrUpdateRes.data &&
      saveOrUpdateRes.data.status === 500 &&
      saveOrUpdateRes.data.data &&
      saveOrUpdateRes.data.data.message
    ) {
      handleSetErrorMessages([saveOrUpdateRes?.data?.data?.message]);
    }
  }, [saveOrUpdateRes]);

  useEffect(() => {
    if (disableSaveAndCancel && allContactData?.key && !addGroup && !contactFormDirty) {
      setResetContactSnapshot(
        JSON.parse(JSON.stringify(allContactData))
      );
    }
  }, [allContactData, disableSaveAndCancel, addGroup, contactFormDirty]);

  /** Refresh functionalities */
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (
          item.navTo === '/group-maintain' &&
          (!disableSaveAndCancel || contactFormDirty)
        ) {
          item.isFormDirty = true;
          if (errorMessages && errorMessages.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        } else if (item.navTo === '/group-maintain') item.isFormDirty = false;
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [disableSaveAndCancel, contactFormDirty, errorMessages, groupDetails]);

  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/group-maintain' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/group-maintain' && item.isFormSave) {
          item.isFormSave = false;
          setClickOncloseTabBtn(false);
          saveOrUpdateHandler();
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  useEffect(() => {
    if (navigationListener) {
      const navTo = navigationListener;
      dispatch(setNaviagtionListner(null));
      if (navTo === 'group') {
        const updateTabs =
          JSON.parse(localStorage.getItem('tabItemsData')) === null
            ? []
            : JSON.parse(localStorage.getItem('tabItemsData'));

        localStorage.setItem(
          'tabItemsData',
          JSON.stringify(
            updateTabs.filter((item) => item.navTo !== '/group-maintain')
          )
        );

        history.replace('/group');
      }
    }
  }, [navigationListener]);

  const handleDeleteGroup = () => {
    if (plans && plans.length > 0) {
      setErrorMessages([DELETE_GROUP_WARN]);
    } else {
      setOpenDelete(true);
    }
  };

  const formatCGPPayload = (payload) => {
    const cgVOListFormatted = [];
    if (payload && payload.length > 0) {
      payload.map((dataItem) => {
        const temObj = {
          endDt: dataItem.endDt,
          groupName: dataItem.groupName,
          lastUpdateDt: dataItem.lastUpdateDt,
          lastUpdateUserId: dataItem.lastUpdateUserId,
          corrLinkId: dataItem.corrLinkId,
          clientName: dataItem.clientName,
          clientGroupId: {
            clientId: dataItem.clientGroupId.clientId,
            groupId: dataItem.clientGroupId.groupId,
            startDt: dataItem.clientGroupId.startDt,
          },
          newRecord: dataItem.newRecord || false,
          updateRecord: dataItem.updateRecord || false,
          oldStartDt: dataItem.oldStartDt,
        };
        cgVOListFormatted.push(temObj);
      });
      let formattedPayload = {};
      let contactData = {};
      if (contactFormDirty) {
        let newPhn =
          allContactData &&
          allContactData.phoneNum &&
          allContactData.phoneNum.replace(/-| |/g, '');
        if (newPhn) {
          newPhn = newPhn.replace('(', '');
          newPhn = newPhn.replace(')', '');
          contactData = { ...allContactData, phoneNum: newPhn };
        } else {
          contactData = { ...allContactData };
        }
      }
      formattedPayload = {
        clientGroupVOList: cgVOListFormatted,
        contactVO: contactData,
      };
      return formattedPayload;
    }
    return handleSetErrorMessages([message.ERROR_MESSAGE]);
  };
  const formatDate = (date) => {
  if (!date) return '';

  const d = new Date(date);
  if (isNaN(d)) return '';

  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const yyyy = d.getFullYear();

  return `${mm}/${dd}/${yyyy}`;
};

  const saveOrUpdateHandler = () => {
  const saveRequest = [...particpationDates].filter((r) => !r.deleted);
    const errorMessagesArray = [];
    let participateDateError = true;
    let showClientIdError = false;
    let showGroupIdError = false;
    let showGroupNameError = false;
    let showStartDateError = false;
    let showEndDateGreaterError = false;
    let showEndDareErr = false;
    let showInvalidStartDateOrEndDateError = false;
    let dateOverlaping = false;
    let ContactErr = false;
    let clientIdError = '';
    let groupIdError = '';
    if (
      !groupDetails ||
      groupDetails.clientId === null ||
      groupDetails.clientId === '-1'
    ) {
      showClientIdError = true;
      clientIdError = 'Client ID is required';
      errorMessagesArray.push(clientIdError);
    }
    if (
      addGroup &&
      groupDetails &&
      groupDetails.clientId &&
      (!groupDetails || !groupDetails.groupId || groupDetails.groupId === '-1')
    ) {
      showGroupIdError = true;
      groupIdError = 'Group ID is required';
      errorMessagesArray.push(groupIdError);
    }

    for (let i = 0; i < saveRequest.length; i += 1) {
      if (saveRequest[i].clientGroupId.startDt) {
        participateDateError = false;
      }

      if (
        !saveRequest[i].clientGroupId.startDt &&
        showStartDateError === false
      ) {
        showStartDateError = true;
        errorMessagesArray.push(
          `Participation Start Date is required on row #${i + 1}`
        );
      }

      if (!saveRequest[i].groupName && showGroupNameError === false) {
        showGroupNameError = true;
        errorMessagesArray.push(`Group Name is required on row #${i + 1}`);
      }
      
  const rawStartDt = saveRequest[i].clientGroupId.startDt;
  const rawEndDt = saveRequest[i].endDt;
  const formattedStartDt = formatDate(rawStartDt);
  const formattedEndDt = formatDate(rawEndDt);
      if (rawStartDt && !isValidDateFormat(formattedStartDt)) {
        showInvalidStartDateOrEndDateError = true;
        errorMessagesArray.push(message.INVALID_DATE_FORMAT);
      }

      if (rawEndDt && !isValidDateFormat(formattedEndDt)) {
        showInvalidStartDateOrEndDateError = true;
        errorMessagesArray.push(message.INVALID_DATE_FORMAT);
      }

      if (
        saveRequest[i].clientGroupId.startDt &&
        saveRequest[i].endDt &&
        !showInvalidStartDateOrEndDateError &&
        compareTwoDatesGreaterThanOrEqual(
          saveRequest[i].endDt,
          saveRequest[i].clientGroupId.startDt
        )
      ) {
        showEndDateGreaterError = true;
        errorMessagesArray.push(
          `End Date is before Start Date on row #${i + 1}`
        );
      }

      if (
        formattedEndDt &&
        !showInvalidStartDateOrEndDateError &&
        !validDate(new Date(formattedEndDt))
      ) {
        showInvalidStartDateOrEndDateError = true;
        errorMessagesArray.push(message.INVALID_DATE_FORMAT);
      }

      const endDtEmptyError = saveRequest.filter((item) => !item.endDt);
      if (endDtEmptyError.length > 1 && !showEndDareErr) {
        showEndDareErr = true;
        errorMessagesArray.push(message.ONE_EMPTY_END_DT);
      }

      for (let j = i + 1; saveRequest.length > j; j += 1) {
        if (dateOverlaping) {
          break;
        } else if (
          validDate(new Date(saveRequest[i].clientGroupId.startDt)) &&
          validDate(new Date(saveRequest[i].endDt)) &&
          validDate(new Date(saveRequest[j].clientGroupId.startDt)) &&
          validDate(new Date(saveRequest[j].endDt)) &&
          saveRequest[i].clientGroupId.startDt ===
            saveRequest[j].clientGroupId.startDt &&
          saveRequest[i].endDt === saveRequest[j].endDt
        ) {
          dateOverlaping = true;
          errorMessagesArray.push(
            `Start and End Date overlap in row #${i + 1} and ${j + 1}`
          );
        }
      }
    }
    if (contactFormDirty && contactErrors && contactErrors.length > 0) {
      ContactErr = true;
    }

    if (participateDateError) {
      errorMessagesArray.push(message.PARTICIPATE_DATE_REQ);
    }

    if (
      dateOverlaping ||
      showInvalidStartDateOrEndDateError ||
      showEndDateGreaterError ||
      showClientIdError ||
      showGroupIdError ||
      showGroupNameError ||
      showStartDateError ||
      participateDateError ||
      showEndDareErr ||
      ContactErr
    ) {
      const allErrors = ContactErr
        ? contactErrors.concat(errorMessagesArray)
        : errorMessagesArray;
      handleSetErrorMessages([...new Set(allErrors)]);
      setSucessMessage([]);
      return;
    }
    handleSetErrorMessages([]);
    setSucessMessage([]);
    let apiRequest = [];

    const deletedRecords = [...particpationDates].filter((r) => r.deleted && !r.newRecord);
    if (deletedRecords && deletedRecords.length > 0) {
      dispatch(async () => {
        const mod = await import('../store/group-action');
        if (mod && mod.deleteGroupDetils) {
          try {
            await mod.deleteGroupDetils(deletedRecords);
          } catch (e) {
          }
        }
      });
    }

    apiRequest = saveRequest.map((item) => {
      const formattedStrDt =
        item.clientGroupId.startDt !== 'Invalid Date'
          ? getUTCTimeStampMMDDYYYY(item.clientGroupId.startDt)
          : null;
      let formattedEndDt;
      if (item.endDt) {
        formattedEndDt =
          item.endDt && item.endDt !== 'Invalid Date'
            ? getUTCTimeStampMMDDYYYY(item.endDt)
            : null;
      } else {
        formattedEndDt =
          item.endDt && item.endDt !== 'Invalid Date'
            ? getUTCTimeStampMMDDYYYY(item.endDt)
            : null;
      }
      return {
        newRecord: !!item.newRecord,
        updateRecord: !!item.updateRecord,
        oldStartDt: item.oldStartDt,
        endDt: formattedEndDt,
        groupName: item.groupName,
        corrLinkId: item.corrLinkIdl,
        lastUpdateDt: item.lastUpdateDt
          ? getUTCTimeStampMMDDYYYY(item.lastUpdateDt)
          : '',
        lastUpdateUserId: item.lastUpdateUserId || '',
        clientName: groupDetails.clientName,
        clientGroupId: {
          startDt: formattedStrDt,
          clientId: groupDetails.clientId,
          groupId: groupDetails.groupId,
        },
      };
    });
    const payloadFinal = formatCGPPayload(apiRequest);
    dispatch(saveOrUpdateGroup(payloadFinal));
  };

  const callGetDetailsAPI = () => {
    if (groupDetails && groupDetails.clientId && groupDetails.groupId) {
      dispatch(
        setGroupDetailsAndParticptionDates(
          groupDetails.groupId,
          groupDetails.clientId
        )
      );
    }
  };

  useEffect(() => {
    if (
      tabValue === 'two' &&
      groupDetails &&
      groupDetails.groupId &&
      groupDetails.clientId
    ) {
      dispatch(
        getAllPlans({
          groupId: groupDetails.groupId,
          clientId: groupDetails.clientId,
        })
      );
    }
    if (tabValue === 'three') {
      dispatch(
        setMainGroupDetailsAction({
          ...groupDetails,
          ...allContactData,
        })
      );
    }
  }, [tabValue]);

  const onConfirmCancel = () => {
    if (addGroup) {
      dispatch(setMainGroupDetailsAction(null));
      dispatch(setMaintainGroupParticipationDatesAction([]));
      dispatch(setCompareData({ details: null, data: [] }));
      dispatch(resetPlanContactData());
      handleBlurForDataChange();
    } else {
      if (resetContactSnapshot) {
        dispatch(
          saveContactData(JSON.parse(JSON.stringify(resetContactSnapshot)))
        );
        const clientId = groupDetails?.clientId?.trim();
        const groupId = groupDetails?.groupId?.trim();
        if (
          resetContactSnapshot.contactTypeCd &&
          resetContactSnapshot.contactTypeCd !== '-1' &&
          clientId &&
          groupId
        ) {
          dispatch(
            getContactDetails(
              {
                keyTypeCd: 'CG',
                key: `${clientId}${groupId}`,
                contactTypeCd: resetContactSnapshot.contactTypeCd,
              },
              'group'
            )
          );
        }
      }
      callGetDetailsAPI();
      handleSetDisableSaveAndCancel(true);
      setContactFormDirty(false);
    }
    setContactErrors([]);
    setCancelPopup(false);
    handleSetErrorMessages([]);
    setSucessMessage([]);
  };

  const handleBlurForDataChange = () => {
    handleSetDisableSaveAndCancel(false);
    dispatch(setGroupDataChangeTried(Math.random()));
  };

  useEffect(() => {
    if (
      (_.isEqual(groupDetails, compareData.details) &&
        _.isEqual(particpationDates, compareData.data) &&
        _.isEqual(contactDetails, compareContactDetails)) ||
      !groupTabData
    ) {
      handleSetDisableSaveAndCancel(true);
    } else if (createfirst) {
      dispatch(setCreateGrpOpt(false));
      handleSetDisableSaveAndCancel(true);
    } else {
      handleSetDisableSaveAndCancel(false);
    }
  }, [dataChangeTried]);

  useEffect(() => {
    if (errorPopup) {
      if (errorPopup === 'successfully deleted') {
        setSucessMessage([message.SUCESS_MESSAGE]);
      } else {
        setSucessMessage([]);
        setErrorMessages([errorPopup]);
      }
    }else{
      setErrorMessages([]);
    }
  }, [errorPopup]);
  return (
    <>
      <CancellationPopup
        label="There are unsaved changes. Do you want to continue?"
        open={cancelPopup}
        handleClose={() => setCancelPopup(false)}
        onConfirmClick={() => onConfirmCancel()}
      />

      <SaveCancelPopup
        data-testid="handleDeleteAll"
        open={openDelete}
        title="Delete Group"
        content="This will delete the group and all the participation dates"
        onConfim={() => {
          dispatch(deleteGroup(particpationDates));
          setOpenDelete(false);
        }}
        onCancel={() => {
          setOpenDelete(false);
        }}
        onClose={(reason) => {
          if (reason === 'backdropClick' && reason === 'escapeKeyDown') {
            setOpenDelete(false);
          }
        }}
        aria-label="delete"
      />
      <CancellationPopup
        modalTitle="Save"
        label="Are you sure you want to Save your changes? To revert changes, click on Cancel"
        open={savePopup}
        handleClose={() => setSavePopup(false)}
        onConfirmClick={async () => {
          setClickOncloseTabBtn(true);
          await saveOrUpdateHandler();
          setSavePopup(false);
        }}
      />
      <div className="tBillPanel custom-check">
        <div className="panel tBillPanel-space pb-0">
          <Spinner load={spinnerLoader} />
          <CustomSeparator parent1="Maintain" parent2="Maintain Group" />
          {!fullScreenView && (
            <>
              <DisplaySuccessMessages successMessages={successMessages} />
              <DisplayErrorMessages errorMessages={errorMessages} />
            </>
          )}
          {!fullScreenView && (
            <fieldset className="custom-fieldset">
              <form autoComplete="off">
                <div className="form-wrapper form-wrapper-col-3">
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="Client_ID"
                      label="Client ID"
                      fullWidth
                      required
                      select
                      disabled={!addGroup}
                      value={
                        groupDetails && groupDetails.clientId
                          ? groupDetails?.clientId
                          : '-1'
                      }
                      placeholder=""
                      inputProps={{
                        maxlength: 150,
                        'aria-labelledby': 'Client_ID',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      aria-label="Client_ID"
                      onBlur={handleBlurForDataChange}
                      onChange={(e) => {
                        if (e.target.value) {
                          const index = clientIdDropdown.findIndex(
                            (item) => item.clientId === e.target.value
                          );

                          if (index !== -1) {
                            const obj = !groupDetails
                              ? {}
                              : { ...groupDetails };
                            obj.clientId = clientIdDropdown[index].clientId;
                            obj.clientName = clientIdDropdown[index].clientName;

                            dispatch(setMainGroupDetailsAction(obj));
                          } else {
                            const obj = !groupDetails
                              ? {}
                              : { ...groupDetails };
                            obj.clientId = e.target.value;
                            obj.clientName = '';
                            dispatch(setMainGroupDetailsAction(obj));
                          }
                        }
                      }}
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {clientIdDropdown && clientIdDropdown.length > 0
                        ? clientIdDropdown?.map((item, index) => {
                            return (
                              <MenuItem
                                key={`${index + 1}`}
                                value={item.clientId}
                                className="frr-logcheck-dropdown-item"
                              >
                                {item.clientId}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="Client_Name"
                      label="Client Name"
                      fullWidth
                      disabled
                      value={(groupDetails && groupDetails.clientName) || ''}
                      placeholder=""
                      inputProps={{
                        maxlength: 60,
                        'aria-labelledby': 'Client_Name',
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      aria-label="Client_Name"
                    />
                  </div>
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="Group ID"
                      label="Group ID"
                      fullWidth
                      required
                      placeholder=""
                      inputProps={{ maxlength: 150 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={
                        !addGroup ||
                        !(addGroup && groupDetails && groupDetails.clientId)
                      }
                      value={(groupDetails && groupDetails.groupId) || ''}
                      onBlur={handleBlurForDataChange}
                      onChange={(e) => {
                        const obj = !groupDetails ? {} : { ...groupDetails };
                        obj.groupId = e.target.value;
                        dispatch(setMainGroupDetailsAction(obj));
                      }}
                    />
                  </div>
                </div>
                <div className="form-wrapper form-wrapper-col-3">
                  <div className="mui-custom-form input-md">
                    <TextField
                      id="Group Name"
                      label="Group Name"
                      fullWidth
                      placeholder=""
                      inputProps={{ maxlength: 60 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled
                      value={(groupDetails && groupDetails.groupName) || ''}
                      onBlur={handleBlurForDataChange}
                      onChange={(e) => {
                        const obj = !groupDetails ? {} : { ...groupDetails };
                        obj.groupName = e.target.value;
                        dispatch(setMainGroupDetailsAction(obj));
                      }}
                    />
                  </div>
                </div>
              </form>
            </fieldset>
          )}
          {!fullScreenView && (
            <div className="btn-wrapper mb-2">
              <div className="float-right mt-2 hide-on-print">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="saveBtn"
                  disabled={
                    (disableSaveAndCancel && !contactFormDirty) ||
                    !isEnablebyRole
                  }
                  onClick={() => setSavePopup(true)}
                >
                  <SVGComponent iconName="Icon-awesome-save" />
                  Save
                </Button>
                <Button
                  onClick={() => setCancelPopup(true)}
                  disabled={disableSaveAndCancel && !contactFormDirty}
                  data-testid="cancelBtn"
                  className="btn btn-cancel btn btn-primary"
                >
                  <SVGComponent iconName="Icon-cancel" />
                  Cancel
                </Button>
              </div>
              <div className="clearfix" />
            </div>
          )}
          {!addGroup &&
            checkActionAccessByRole(
              process.env.REACT_APP_HIDE_ACCESS_ROLES,
              kcRoles
            ) && <Action setOpenDelete={handleDeleteGroup} />}
          <div className="tabs-wrapper">
            <div className="float-left">
              <MaintainGroupTabContainer
                handleChangeTabValue={handleChangeTabValue}
                tabValue={tabValue}
                errorMessages={errorMessages}
              />
            </div>
            <div className="clearfix" />
          </div>
          <div className="tabs-body">
            {tabValue === 'one' ? (
              <div
                style={{ height: '400px', width: '100%' }}
                className="ag-theme-alpine"
              >
                <MainGroupParticipationDates
                  cellHead={PARTICPATION_DATES}
                  setDisableSaveAndCancel={handleSetDisableSaveAndCancel}
                  disableSaveAndCancel={disableSaveAndCancel}
                  fullScreenView={fullScreenView}
                  setFullScreenView={setFullScreenView}
                  setSucessMessage={setSucessMessage}
                  setErrorMessages={setErrorMessages}
                  getExistingCommentLinkIds={getExistingCommentLinkIds}
                  hasAccessbyRole={hasAccessbyRole}
                  kcRoles={kcRoles}
                  isEnablebyRole={isEnablebyRole}
                  isReadOnly={isReadOnly}
                />
              </div>
            ) : null}
            {tabValue === 'two' ? (
              <div
                style={{ height: '400px', width: '100%' }}
                className="ag-theme-alpine"
              >
                <MaintainGroupPlan
                  data={plans}
                  fullScreenView={fullScreenView}
                  setFullScreenView={setFullScreenView}
                  cellHead={MAINTAIN_GROUP_PLANS}
                />
              </div>
            ) : null}
            <div
              style={{
                display: tabValue === 'three' ? 'block' : 'none',
              }}
            >
              <PlanContactForm
                keyId={`${groupDetails?.clientId?.trim()}${groupDetails?.groupId?.trim()}`}
                setContactErrors={setContactErrors}
                defaultValues={groupDetails}
                entityType="CG"
                keyTypeCd="CG"
                contactType="Group"
                setIsFormChanged={handleSetDisableSaveAndCancel}
                onContactDirtyChange={setContactFormDirty}
                contactFormDirty={contactFormDirty}
                savePopup={savePopup}
                setSuccessMessage={setSucessMessage}
                setErrorMessages={setErrorMessages}
              />
            </div>
          </div>
        </div>
      </div>
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={setShowComments}
          linkTableName="GROUP"
          corrLinkId={
            particpationDates &&
            particpationDates.length > 0 &&
            particpationDates[0]?.corrLinkId
          }
          rowGridPrimaryKey={
            particpationDates && particpationDates.length > 0
              ? `${particpationDates[0]?.clientGroupId?.clientId}${particpationDates[0]?.clientGroupId?.groupId}`
              : 0
          }
        />
      ) : null}
    </>
  );
};

export default MainGroup;
